import React, {useEffect, useState} from "react";
import {Col, Form} from "react-bootstrap";
import Spinner from "../../components/Spinner";
import TextArea from "../Fields/TextArea";
import TextField from "../Fields/TextField";
import TextbausteinSchema from "./TextbausteinSchema";
import SelectField from "../Fields/SelectField";
import {translate} from "../../components/Language/Translate";
import {useDispatch, useSelector} from "react-redux";
import {updateTextbausteinOnAPI} from "../../actions/textbausteine";

const TextbausteinEdit = ({id, backFunc}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [variables, setVariables] = useState({});
  const [fieldSettings, setFieldSettings] = useState({});
  const [serverError, setServerError] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const dispatch = useDispatch();
  const textbausteine = useSelector(st => st.textbausteine);
  const tb = textbausteine.find(tBa => tBa.id === id);
  const sendData = ["type", "number", "text", "punkte"];
  useEffect(() => {
    console.log("inside useEffect");
    const fetch = () => {
      const sets = new TextbausteinSchema();
      (() => setFieldSettings({...sets.fields}))();
      (() => setVariables({...tb}))();
      (() => setIsLoading(false))();
    };
    if (isLoading) fetch();
  }, [isLoading, setFieldSettings, setVariables, setIsLoading, tb]);

  if (isLoading) return <Spinner />;
  const handleChange = e =>
    setVariables(vars => {
      return {...vars, [e.target.name]: e.target.value};
    });

  const props = {
    variables,
    setVariables,
    fieldSettings,
    setFieldSettings,
    fieldErrors,
    setFieldErrors,
    serverError,
    setServerError,
    handleChange
  };
  console.log({props});

  const getPunkteArr = () => {
    return variables.punkte
      .split(",")
      .map(i => parseInt(i.trim()))
      .sort((a, b) => (a > b ? -1 : 1));
  };

  const validate = () => {
    const fErr = {};
    const punkteArr = getPunkteArr();
    if (!punkteArr.every(i => [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].includes(i)))
      fErr.punkte = "Ungültige Werte. Nur Zahlen von 0-15 sind erlaubt";
    setFieldErrors({...fErr});
    return Object.keys(fErr).length === 0;
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (!validate()) return;
    const data = {};
    sendData.forEach(i => (data[i] = variables[i]));
    data.punkte = getPunkteArr().join(", ");
    console.log({data});
    dispatch(updateTextbausteinOnAPI(id, data));
    backFunc();
  };

  return (
    <div>
      <Form onSubmit={e => handleSubmit(e)}>
        <Form.Row>
          <Col className="col-9">
            <SelectField name="type" props={props} />
          </Col>

          <Col className="col-3">
            <SelectField name="number" props={props} />
          </Col>
        </Form.Row>

        <TextArea name="text" props={props} />
        <TextField name="punkte" props={props} />
        <button type="submit" className="btn btn-outline-dark">
          {translate("Submit")}
        </button>
      </Form>
    </div>
  );
};
export default TextbausteinEdit;
